var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.707 17.293a1 1 0 0 0 1.414 1.414L12 12.828l5.879 5.879a1 1 0 0 0 1.414-1.414l-5.879-5.88L18.85 5.98a1 1 0 0 0-1.414-1.414L12 10 6.565 4.565A1 1 0 0 0 5.15 5.979l5.435 5.435-5.879 5.879Z",
    clipRule: "evenodd"
  })));
};
export default SvgCross;